"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Rendering {
    constructor(dymoUri) {
        this.dymoUri = dymoUri;
    }
    getDymoUri() {
        return this.dymoUri;
    }
}
exports.Rendering = Rendering;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/model/rendering.js
// module id = 1311
// module chunks = 3